










import { Component, Vue } from 'vue-property-decorator';
import ScenarioGenerator from '../components/scenario-generator.vue';

@Component({
  components: { ScenarioGenerator },
})
export default class ScenarioView extends Vue {
  private init() {
    this.$store.states.map(s => {
      if (!s.scenarios.current && s.scenarios.list && s.scenarios.list.length > 0) {
        const id = s.scenarios.list[0].id;
        id && this.$store.actions.scenarios.load(id);
      }
    });
  }

  mounted(): void {
    console.log(`ScenarioView mounted`);
    this.init();
  }
}
